import { c as _c } from "react/compiler-runtime";
import { Checkbox } from "@flat-ui";
import { SHOW_ON_HOVER_CLASS } from "@utils/ui-utils";
import { forwardRef } from "react";

/**
 * What MUI X hands to its checkbox slots: their own normalised contract, plus the `material`
 * escape hatch it passes at runtime but leaves out of its public types.
 */

/**
 * Custom checkbox to select elements. Applies both to the one in the header and in the other rows.
 *
 * The slot contract does not line up with flat-ui's `Checkbox`, so the props are translated rather
 * than spread: `material` has to be unpacked, since forwarding it renders `material="[object Object]"`
 * into the DOM, and the grid puts `aria-label` and `name` in `slotProps.htmlInput`, which
 * `Checkbox` calls `inputProps`.
 */
export const FaroCustomCheckbox = forwardRef(function FaroCustomCheckbox(t0, ref) {
  const $ = _c(27);
  let className;
  let controlSx;
  let material;
  let name;
  let rest;
  let slotProps;
  let t1;
  if ($[0] !== t0) {
    const {
      isRowCheckbox: t2,
      slotProps: t3,
      material: t4,
      className: t5,
      controlSx: t6,
      name: t7,
      density: _density,
      ...t8
    } = t0;
    t1 = t2;
    slotProps = t3;
    material = t4;
    className = t5;
    controlSx = t6;
    name = t7;
    rest = t8;
    $[0] = t0;
    $[1] = className;
    $[2] = controlSx;
    $[3] = material;
    $[4] = name;
    $[5] = rest;
    $[6] = slotProps;
    $[7] = t1;
  } else {
    className = $[1];
    controlSx = $[2];
    material = $[3];
    name = $[4];
    rest = $[5];
    slotProps = $[6];
    t1 = $[7];
  }
  const isRowCheckbox = t1 === undefined ? false : t1;
  const isChecked = rest.checked || rest.indeterminate;
  const t2 = material?.className;
  let t3;
  if ($[8] !== className || $[9] !== t2) {
    t3 = [className, t2, SHOW_ON_HOVER_CLASS].filter(Boolean);
    $[8] = className;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const t4 = t3.join(" ");
  const t5 = slotProps?.htmlInput;
  let t6;
  if ($[11] !== name || $[12] !== t5) {
    t6 = {
      name,
      ...t5
    };
    $[11] = name;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const t7 = isChecked || !isRowCheckbox ? "visible" : "hidden";
  let t8;
  if ($[14] !== t7) {
    t8 = {
      visibility: t7
    };
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== controlSx) {
    t9 = Array.isArray(controlSx) ? controlSx : [controlSx];
    $[16] = controlSx;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t8 || $[19] !== t9) {
    t10 = [t8, ...t9];
    $[18] = t8;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== ref || $[22] !== rest || $[23] !== t10 || $[24] !== t4 || $[25] !== t6) {
    t11 = <Checkbox {...rest} ref={ref} className={t4} inputProps={t6} controlSx={t10} />;
    $[21] = ref;
    $[22] = rest;
    $[23] = t10;
    $[24] = t4;
    $[25] = t6;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  return t11;
});

/**
 * Renders the checkbox of a table row. Registered as the grid's `rowCheckbox` slot, which is what
 * distinguishes a row checkbox from the header one -- previously this was guessed by matching
 * against the `aria-label` string, which MUI owns and moved in v9.
 */
export const FaroCustomRowCheckbox = forwardRef(function FaroCustomRowCheckbox(t0, ref) {
  const $ = _c(7);
  let material;
  let rest;
  if ($[0] !== t0) {
    const {
      rowId: _rowId,
      material: t1,
      ...t2
    } = t0;
    material = t1;
    rest = t2;
    $[0] = t0;
    $[1] = material;
    $[2] = rest;
  } else {
    material = $[1];
    rest = $[2];
  }
  let t1;
  if ($[3] !== material || $[4] !== ref || $[5] !== rest) {
    t1 = <FaroCustomCheckbox {...rest} material={material} isRowCheckbox={true} ref={ref} />;
    $[3] = material;
    $[4] = ref;
    $[5] = rest;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
});